exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2D0Tw3Y-NYZaOp5nd_jNpv{background-color:#fff;height:100%;overflow-y:scroll}._6f1WwsvCrJQu6wvFwALqo{border-bottom:1px solid #e0e0e0;display:flex;justify-content:space-between;align-items:center;padding:15px}._6GMOhe6eYDRRoNNlxdcJo{flex:0 1 auto}._1PmdEb3VecDFusn02Zo9CS{flex:0 1 auto;height:28px}._1ML3eWWRh_bRlr6XfIGGEX{font-size:18px;line-height:22px}._1ML3eWWRh_bRlr6XfIGGEX a{text-decoration:none}._2ZxWUKzcrkojNJsMVagV6e{font-size:14px;color:#424242}\n", ""]);

// Exports
exports.locals = {
	"EventsEmbed": "_2D0Tw3Y-NYZaOp5nd_jNpv",
	"header": "_6f1WwsvCrJQu6wvFwALqo",
	"left": "_6GMOhe6eYDRRoNNlxdcJo",
	"logo": "_1PmdEb3VecDFusn02Zo9CS",
	"title": "_1ML3eWWRh_bRlr6XfIGGEX",
	"description": "_2ZxWUKzcrkojNJsMVagV6e"
};